/**
 * The local editing shapes behind Settings → Analysis, and the one question
 * about them worth asking on its own.
 *
 * Split from the component so it can be tested directly — and so the component
 * file keeps exporting nothing but a component, which is what Fast Refresh
 * needs to stay working.
 */

/** A stable key so React keeps inputs mounted while someone is typing in them. */
export type DraftSection = {
  key: string;
  _id?: string;
  title: string;
  prompt: string;
};

export type Draft = {
  key: string;
  _id?: string;
  name: string;
  icon: string;
  copied_from?: string;
  sections: DraftSection[];
};

export const BLANK_NAME = "New agent";
export const BLANK_SECTION_TITLE = "Section 1";

/**
 * A blank the reader has not typed into yet.
 *
 * Unsaved (`_id`-less) and still carrying every default it was born with, so
 * reusing it loses nothing. Anything edited — even just renamed — is real work
 * and gets left alone; so does anything the server has saved, since an
 * agent someone genuinely called "New agent" is their template, not a
 * stray click.
 */
export const isUntouchedBlank = (draft: Draft): boolean =>
  !draft._id &&
  draft.name === BLANK_NAME &&
  draft.sections.length === 1 &&
  draft.sections[0].title === BLANK_SECTION_TITLE &&
  draft.sections[0].prompt === "";
